import ObjectStorage from "./ObjectStorage";

export default class Oss {
  static createOss(Vue){
    if(!ObjectStorage.isOssConfig()) {
      ObjectStorage.getOssConfig(config=>{
        Vue.prototype.$oss = new ObjectStorage(config);
        window.__OSS__=Vue.prototype.$oss;
      })
    }else if(!Vue.prototype.$oss){
      Vue.prototype.$oss = new ObjectStorage(ObjectStorage.isOssConfig());
      window.__OSS__=Vue.prototype.$oss;
    }else {
      Vue.prototype.$oss=null
      window.__OSS__=Vue.prototype.$oss;
    }
  }
  static install(Vue){
    Oss.createOss(Vue)
  }
}



// WEBPACK FOOTER //
// ./src/common/Oss.js